import { useState } from 'react';
import { useAsyncEffect } from 'rooks';
import { sqConditionMonitorsApi } from '@seeqdev/api/endpoint/ConditionMonitorsApi';
import type { ConditionMonitorOutputV1 } from '@seeqdev/api/model/ConditionMonitorOutputV1';

/**
 * The Evidence table's condition monitor. Refetches when `refetchKey` changes, e.g. once per finished run, so the
 * stopped state and lastRunAt stay current. Runs can finish in quick succession, so an older response never overwrites a
 * newer one.
 */
export function useEvidenceConditionMonitor(conditionMonitorId?: string, refetchKey?: string) {
  const [conditionMonitor, setConditionMonitor] = useState<ConditionMonitorOutputV1>();

  useAsyncEffect(
    async (shouldContinueEffect: () => boolean) => {
      if (!conditionMonitorId) {
        return;
      }
      const { data } = await sqConditionMonitorsApi.getConditionMonitor({ id: conditionMonitorId });
      if (shouldContinueEffect()) {
        setConditionMonitor(data);
      }
    },
    [conditionMonitorId, refetchKey],
  );

  return conditionMonitor;
}
